export const openUrl = (url) => {
  open(url)
}
